export enum DriverDayQueryOrdersSort {
  DRIVER_DAY_DATE = 'driver_day_date',
  DRIVER_NAME = 'driver_name',
  VENDOR_ACCOUNT_NAME = 'vendor_account_name',
}
